<template>
  <el-row type="flex" justify="center" align="middle" :gutter="5">
    <el-col :span="11">
      <GridVx
        ref="agGridPackage"
        :columns="column1"
        :rows="row1"
        class="agGrid"
      />
    </el-col>
    <el-col :span="2">
      <el-row type="flex" justify="center"
        ><el-button
          type="primary"
          icon="el-icon-d-arrow-right"
          style="margin-bottom: 10px"
          @click="nextToChoice"
      /></el-row>
      <el-row type="flex" justify="center"
        ><el-button
          type="primary"
          icon="el-icon-d-arrow-left"
          @click="undoChoice"
      /></el-row>
    </el-col>

    <el-col :span="11">
      <GridVx
        ref="agGridPackageChoice"
        :columns="column2"
        :rows="row2"
        class="agGrid"
      />
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    column1: {
      type: Array,
      default: () => []
    },
    row1: {
      type: Array,
      default: () => []
    },
    column2: {
      type: Array,
      default: () => []
    },
    row2: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    nextToChoice() {
      const gridApi = this.$refs.agGridPackage.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      this.row1 = this.row1.filter(row => !rowsSelected.includes(row))
      this.row2.push(...rowsSelected)
      this.$emit('nextToChoice', { row1: this.row1, row2: this.row2 })
    },
    undoChoice() {
      const gridApi = this.$refs.agGridPackageChoice.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      this.row2 = this.row2.filter(row => !rowsSelected.includes(row))
      this.row1.push(...rowsSelected)
      this.$emit('undoChoice', { row1: this.row1, row2: this.row2 })
    }
  }
}
</script>

<style lang="scss" scoped></style>
